/**
 * components/landing/resources/ResourcesPage.jsx — Phase 8 · Resources
 * Center orchestrator. Composes the 13 sections in narrative order.
 */

import SiteFrame  from '@/components/landing/SiteFrame'
import Hero           from './sections/Hero'
import Categories     from './sections/Categories'
import Documentation  from './sections/Documentation'
import Guides         from './sections/Guides'
import Academy        from './sections/Academy'
import Videos         from './sections/Videos'
import KnowledgeBase  from './sections/KnowledgeBase'
import ReleaseNotes   from './sections/ReleaseNotes'
import ApiDocs        from './sections/ApiDocs'
import FAQs           from './sections/FAQs'
import Support        from './sections/Support'
import Community      from './sections/Community'
import FinalCTA       from './sections/FinalCTA'

const ResourcesPage = () => (
  <SiteFrame hideFooterCta={true}>
    <Hero />
    <Categories />
    <Documentation />
    <Guides />
    <Academy />
    <Videos />
    <KnowledgeBase />
    <ReleaseNotes />
    <ApiDocs />
    <FAQs />
    <Support />
    <Community />
    <FinalCTA />
  </SiteFrame>
)

export default ResourcesPage
